// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-awesome/icons/edit";
import "vue-awesome/icons/remove";
import "vue-awesome/icons/plus";
import "vue-awesome/icons/arrow-up";
import "vue-awesome/icons/arrow-down";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import Notifications from "vue-notification";
import Icon from "vue-awesome/components/Icon";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import config from "@/vue.config";

// globally (in your main .js file)
Vue.component("icon", Icon);
Vue.use(Notifications);
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js